import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import BasePage from './components/ShowPage';
import LoginPage from './components/LoginPage';
import ReactGA from 'react-ga4';
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from './components/AuthProvider';
import './fonts.css';
import SavedPage from './components/SavedPage';
import HeaderFooterLayout from './components/HeaderFooterLayout';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import VisitModal from './components/VisitModal';
import LandingPage from './components/LandingPage';
import { useLocation } from 'react-router-dom';
import ResetPasswordPage from './components/ResetPassword';
import ResetSuccessPage from './components/ResetSuccessPage';
import AppDownloadPopup from './components/AppDownloadPopup';

ReactGA.initialize('G-SCQWPML27C');

const queryClient = new QueryClient();

function InnerApp() {
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalButtons, setModalButtons] = useState([]);
  const [modalTitle, setModalTitle] = useState('');

  const location = useLocation();

  useEffect(() => {
    const handleShowVisitModal = (e) => {
      const { title, message, buttons } = e.detail || {};
      setModalTitle(title || "");
      setModalMessage(message || "");
      setModalButtons(buttons || []);
      setShowModal(true);
    };
  
    const handleCloseVisitModal = () => {
      setShowModal(false);
    };
  
    window.addEventListener("showVisitModal", handleShowVisitModal);
    window.addEventListener("closeVisitModal", handleCloseVisitModal);
  
    return () => {
      window.removeEventListener("showVisitModal", handleShowVisitModal);
      window.removeEventListener("closeVisitModal", handleCloseVisitModal);
    };
  }, []);

  useEffect(() => {
    const reason = localStorage.getItem("redirectReason");
    if (!reason) return;
  
    setTimeout(() => {
      setModalTitle("You're in 🎉")
      setModalMessage("You can now save your fave recs!");
      setModalButtons([
        {
          label: "Go to Saved Recs",
          className: "login-button",
          onClick: () => {
            window.location.href = "/saved";
          },
        },
      ]);
  
      setShowModal(true);
      localStorage.removeItem("redirectReason");
    }, 300); // delay ensures modal shows cleanly post-nav
  }, [location.pathname]); // <-- re-check every time path changes
  
  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <VisitModal
          onClose={handleModalClose}
          message={modalMessage}
          buttons={modalButtons}
          title={modalTitle}
        />
      )}
      <AppDownloadPopup />
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<HeaderFooterLayout><LandingPage /></HeaderFooterLayout>} />
          <Route path="/saved" element={<HeaderFooterLayout><SavedPage /></HeaderFooterLayout>} />
          <Route path="/:id" element={<HeaderFooterLayout><BasePage /></HeaderFooterLayout>} />
          <Route path="/login" element={<HeaderFooterLayout><LoginPage /></HeaderFooterLayout>} />
          <Route path="/browse" element={<HeaderFooterLayout><HomePage /></HeaderFooterLayout>} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/reset-success" element={<ResetSuccessPage />} />
        </Routes>
        <Analytics />
      </QueryClientProvider>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <InnerApp />
      </AuthProvider>
    </Router>
  );
}
